const AnswerUtils = {
    getCurrentAnswer(answer) {
        return answer?.data.answerHistory[answer.data.answerHistory.length - 1];
    },
};
export default AnswerUtils;
